import { StripePaymentElementOptions } from '@stripe/stripe-js'
import { TFunction } from 'i18next'

import { GetMarketShopProductsRequest } from '@/api/market-shop/products/get-market-shop-products'
import { OrderStatusBarStatus } from '@/components/business/market-shop/order-status-bar/order-status-bar.types'
import { MarketShopClientOrderModel } from '@/models'

export const MARKET_SHOP_AUTO_RELOAD_KEY = 'MARKET_SHOP_AUTO_RELOAD_KEY'

export const MARKET_SHOP_CURRENCY = 'usd'

export const CHECK_FOR_OPEN_STATUS_INTERVAL = 5000

export const MAX_NOTE_LENGTH = 290

export const marketShopProductsInitialFilters: GetMarketShopProductsRequest = {
  categoryId: undefined,
  limit: 10,
  search: '',
}

export const STRIPE_PAYMENT_ELEMENT_OPTIONS: StripePaymentElementOptions = {
  layout: 'tabs',
  wallets: {
    applePay: 'auto',
    googlePay: 'auto',
  },
}

export const getOrderStatusToTextsMap = (
  t: TFunction<['market-shop']>,
): Record<
  OrderStatusBarStatus,
  (order: MarketShopClientOrderModel) => { title: string; message: string }
> => ({
  awaiting_pickup: ({ deliveryType }) => ({
    message:
      deliveryType === 'delivery'
        ? t('market-shop:orderStatus.awaitingPickup.messageDelivery')
        : t('market-shop:orderStatus.awaitingPickup.messagePickup'),
    title: t('market-shop:orderStatus.awaitingPickup.title'),
  }),
  in_progress: () => ({
    message: t('market-shop:orderStatus.inProgress.message'),
    title: t('market-shop:orderStatus.inProgress.title'),
  }),
  new: () => ({
    message: t('market-shop:orderStatus.new.message'),
    title: t('market-shop:orderStatus.new.title'),
  }),
})
